
import { getComment, getCommentGood, getNote, getQuestion } from "@/api/home";
import LoadMore from 'vux/src/components/load-more/index.vue'

import { mapGetters } from "vuex";
import { staticHost } from "@/common/js/config";
export default {
components: {
LoadMore
},
computed: {
...mapGetters(["user"])
},
props: {
kind: {
default: "11",
type: String
},
courseKpointId: {
default: 0
}
},
data() {
return {
loading: false,
imgList: {
head: require("@/common/image/course/head.png"),
good: require("@/common/image/course/good.png"),
comment: require("@/common/image/course/comment.png"),
goodActive: require("@/common/image/course/goodActive.png"),
people: require("@/common/image/people.png")
},
show: false,
good: true, //是否点赞
goodNum: 0, // 点赞数
userName: "原以为",
courseid: 0,
commentText: "",
commentList: [],
busy: false,
total: 0,
index: 1,
isLazyLoad: false,
showLoading: false,
staticHost
};
},
methods: {
scrollEvent(e) {
if (this.commentList.length >= this.total) return;
if (
(e.target.scrollingElement.scrollTop +
e.target.scrollingElement.clientHeight >=
e.target.scrollingElement.scrollHeight - 50) && !this.busy
) {
this.busy = true;
}
},

showAll(val) {
val.oper = true;
},

closeAll(val) {
val.oper = false;
},

toGood() {
this.good = false;
this.goodNum += 1;
},

cancelGood() {
this.good = true;
this.goodNum -= 1;
},

initComment() {
this.loading = true;
let dt = {
courseId: this.courseId,
currentPage: 1,
pageSize: 10
};
getComment(dt).then(res => {
this.loading = false;
if (res.entity.assessList) {
this.commentList = res.entity.assessList;
this.total = res.entity.page.totalResultSize;
this.commentList = this.commentList.map(item => {
return {
...item,
oper: false,
images: this.imgList.people
};
});
this.$nextTick(() => {
this.commentList.forEach(item => {
let a = document.getElementById(item.id);
console.log(a.offsetHeight);
if (a.offsetHeight > 66) {
this.$set(item, "showOper", true);
} else {
this.$set(item, "showOper", false);
}
});
});
}
});
},


initQuestion() {
this.loading = true;
let dt = {
courseKpointId: this.courseKpointId,

currentPage: 1,
pageSize: 10
};
getQuestion(dt).then(res => {
this.loading = false;
if (res.entity.questionList) {
this.commentList = res.entity.questionList.map(item => {
return {
nickName: item.nickname,
addTime: item.add_time,
content: item.content,
images: this.imgList.people,
oper: false,
childAnswerQuestionList: item.childQuestionList,
id: item.id
};
});
this.total = res.entity.page.totalResultSize;
this.$nextTick(() => {
this.commentList.forEach(item => {
let a = document.getElementById(item.id);
if (a.offsetHeight > 66) {
this.$set(item, "showOper", true);
} else {
this.$set(item, "showOper", false);
}
});
});
}
});
},

initNote() {
this.loading = true;
let dt = {
courseKpointId: this.courseKpointId,
currentPage: 1,
pageSize: 10

};
getNote(dt).then(res => {
this.loading = false;
if (res.entity.courseNoteList) {
this.commentList = res.entity.courseNoteList.map(item => {
return {
nickName: item.nickname,
addTime: item.updateTime,
images: this.imgList.people,
content: item.content,
oper: false,
id: item.id
};
});
this.$nextTick(() => {
this.commentList.forEach(item => {
let a = document.getElementById(item.id);
console.log(a.offsetHeight);
if (a.offsetHeight > 66) {
this.$set(item, "showOper", true);
} else {
this.$set(item, "showOper", false);
}
});
});
this.total = res.entity.page.totalResultSize;
}
});
},

getGood(id) {
let dt = {

userId: this.user ? this.user.id : "",
commentid: id
};
getCommentGood(dt).then(res => {
if (res.success) {
this.initComment();
}
});
}
},
mounted() {
this.courseId = this.$route.query.courseid;
window.addEventListener("scroll", this.scrollEvent);
switch (this.kind) {
case "question":
this.initQuestion();
break;
case "note":
this.initNote();
break;
case "comment":
this.initComment();
break;
}
},
beforeDestroy() {
window.removeEventListener("scroll", this.scrollEvent);
},
watch: {
kind() {
this.commentList = [];
switch (this.kind) {
case "question":
this.initQuestion();
break;
case "note":
this.initNote();
break;
case "comment":
this.initComment();
break;
}
},
busy(newVal, oldVal) {
console.log(newVal);
if (newVal) {
this.index = this.index + 1;
this.isLazyLoad = true;
let dt = {
currentPage: this.index,
pageSize: 10,
courseKpointId: this.courseKpointId
};
let dtQ = {
courseId: this.courseId,
currentPage: this.index,
pageSize: 10
};
switch (this.kind) {
case "question":
this.loading = true;
getQuestion(dt).then(res => {
this.loading = false;
this.commentList = this.commentList.concat(
res.entity.questionList.map(item => {
return {
nickName: item.nickname,
addTime: item.add_time,
images: this.imgList.people,
content: item.content,
oper: false,
childAnswerQuestionList: item.childQuestionList,
id: item.id
};
})
);
this.$nextTick(() => {
this.commentList.forEach(item => {
let a = document.getElementById(item.id);
console.log(a.offsetHeight);
if (a.offsetHeight > 66) {
this.$set(item, "showOper", true);
} else {
this.$set(item, "showOper", false);
}
});
});
this.busy = false;
this.isLazyLoad = false;
});
break;
case "note":
this.loading = true;
getNote(dt).then(res => {
this.loading = false;
this.commentList = this.commentList.concat(
res.entity.courseNoteList.map(item => {
return {
nickName: item.nickname,
addTime: item.updateTime,
images: this.imgList.people,
content: item.content,
oper: false,
id: item.id
};
})
);
this.$nextTick(() => {
this.commentList.forEach(item => {
let a = document.getElementById(item.id);
console.log(a.offsetHeight);
if (a.offsetHeight > 66) {
this.$set(item, "showOper", true);
} else {
this.$set(item, "showOper", false);
}
});
});
this.busy = false;
this.isLazyLoad = false;
});
break;
case "comment":
this.loading = true;
getComment(dtQ).then(res => {
this.loading = false;
if (res.entity.assessList) {
this.commentList = this.commentList.concat(
res.entity.assessList.map(item => {
return {
...item,
oper: false,
images: this.imgList.people
};
})
);
this.$nextTick(() => {
this.commentList.forEach(item => {
let a = document.getElementById(item.id);
console.log(a.offsetHeight);
if (a.offsetHeight > 66) {
this.$set(item, "showOper", true);
} else {
this.$set(item, "showOper", false);
}
});
});
this.busy = false;
this.isLazyLoad = false;
}
});
break;
}






}
},
$route() {
window.removeEventListener("scroll", this.scrollEvent());
}
}
};



// WEBPACK FOOTER //
// ./src/components/Comment.vue